import { BaseTableProps } from './components/base-table'
import { ColumnDefinitionInterface } from './types/column-interface'
import { InstanceWithIdType } from './types/instance-interface'

export const calculateTableTotalWidth = <T>(columns: ColumnDefinitionInterface<T>[]) =>
  columns
    .filter(c => c.widthPercent !== undefined)
    .reduce((prev, cur) => prev + (cur.widthPercent || 25), 0)

export function resolveRowId<T>({
  row,
  getRowId,
}: {
  row: T
  getRowId?: BaseTableProps<T>['getRowId']
}) {
  if (getRowId) return getRowId(row)
  return (row as InstanceWithIdType).id
}
